// Widget Bahasa Indonesia (membaca): ketuk kalimat, stabilo kata, coba ganti kata,
// pilah kartu ke kelompok, dan urutkan peristiwa (dengan gunung alur cerita).
// Semua teks berasal dari data modul (tepercaya); tetap di-escape lalu diberi **tebal**.
import { esc } from '../../core/format.js';
import { miring } from '../../core/richtext.js';
import { goyang, letup, animasi, jeda } from '../alat.js';

const kaya = t => miring(esc(String(t ?? '')).replace(/\*\*(.+?)\*\*/g, '<b>$1</b>'));
const acak = a => { a = [...a]; for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; } return a; };
const WARNA = { sun: 'var(--sun)', sky: 'var(--sky)', pink: 'var(--pink)', mint: 'var(--mint)', grape: 'var(--grape)', orange: 'var(--orange)' };

/**
 * Ketuk kalimat yang dicari (kalimat utama, kalimat bukti, kalimat sebab, dst.).
 * param: { judul?, kalimat: [teks...], baru?: [indeks awal paragraf baru], target: [indeks...],
 *          label?: 'Kalimat utama', alasan?: { indeks: 'kenapa bukan/kenapa ya' }, salahUmum?, selesai? }
 */
export function pilihKalimat(host, p, ctx) {
  const target = new Set(p.target), ketemu = new Set(), baru = new Set(p.baru || []);
  let html = '<p class="bk-p">';
  p.kalimat.forEach((k, i) => {
    if (i && baru.has(i)) html += '</p><p class="bk-p">';
    html += `<button type="button" class="bk-kal" data-i="${i}">${kaya(k)}</button> `;
  });
  html += '</p>';
  host.innerHTML = `<div class="wg wg-baca">${p.judul ? `<h4 class="bk-judul">${kaya(p.judul)}</h4>` : ''}<div class="bk-teks">${html}</div>
    ${target.size > 1 ? `<p class="bk-hitung" aria-live="polite">Ditemukan <b>0</b> dari ${target.size}</p>` : ''}</div>`;
  const hitung = host.querySelector('.bk-hitung b');
  host.querySelectorAll('.bk-kal').forEach(b => b.addEventListener('click', () => {
    const i = +b.dataset.i;
    if (ketemu.has(i) || b.classList.contains('bukan')) return;
    if (target.has(i)) {
      ketemu.add(i);
      b.classList.add('ya');
      if (p.label) b.insertAdjacentHTML('afterbegin', `<span class="bk-lencana">${esc(p.label)}</span>`);
      letup(b); ctx.sfx.ok?.();
      if (hitung) hitung.textContent = ketemu.size;
      if (ketemu.size === target.size) {
        host.querySelectorAll('.bk-kal').forEach(x => { x.disabled = true; });
        ctx.selesai(p.selesai || 'Tepat! Kamu menemukannya. Tekan **Lanjut**.');
      } else ctx.ucap(p.alasan?.[i] || 'Betul! Masih ada lagi, cari terus.', 'happy');
    } else {
      b.classList.add('bukan');
      goyang(b); ctx.sfx.no();
      ctx.ucap(p.alasan?.[i] || p.salahUmum || 'Belum tepat. Kalimat ini hanya menjelaskan. Coba kalimat lain.', 'think');
      setTimeout(() => b.classList.remove('bukan'), 1400);
    }
  }));
}

// Pecah teks bertanda [frasa|kategori] atau [frasa] menjadi potongan kata.
function potong(teks) {
  const out = [];
  const re = /\[([^\]|]+)(?:\|([^\]]+))?\]|([^\s[\]]+)/g;
  let m, akhir = -1;
  // `nempel`: potongan ini langsung menyambung potongan sebelumnya (mis. tanda baca sesudah [frasa]).
  while ((m = re.exec(teks))) { out.push({ ...(m[3] !== undefined ? { kata: m[3] } : { kata: m[1], kat: m[2] || '*' }), nempel: m.index === akhir }); akhir = re.lastIndex; }
  return out;
}

/**
 * Stabilo kata: tandai kata/frasa yang dicari. Dengan `kategori`, anak memilih warna stabilo dulu.
 * param: { teks: 'Kemarin [sore|waktu] hujan turun di [Bandung|tempat].', kategori?: [{ id, nama, warna }],
 *          petunjuk?: { kategoriAtau*: 'pesan kalau salah' }, selesai? }
 */
export function sorotKata(host, p, ctx) {
  const kat = p.kategori || [{ id: '*', nama: 'Stabilo', warna: 'sun' }];
  const token = potong(p.teks);
  const total = token.filter(t => t.kat).length;
  let aktif = kat[0].id, benar = 0;
  host.innerHTML = `<div class="wg wg-baca">
    ${kat.length > 1 ? `<div class="sk-stabilo" role="group" aria-label="Pilih warna stabilo">${kat.map(k => `<button type="button" class="sk-pena" data-k="${esc(k.id)}" style="--w:${WARNA[k.warna] || WARNA.sun}" aria-pressed="${k.id === aktif}"><i></i>${esc(k.nama)}</button>`).join('')}</div>` : ''}
    <p class="bk-teks sk-teks">${token.map((t, i) => `${i && !t.nempel ? ' ' : ''}<span class="sk-kata" role="button" tabindex="0" data-i="${i}">${kaya(t.kata)}</span>`).join('')}</p>
    <p class="bk-hitung" aria-live="polite">Ditandai <b>0</b> dari ${total}</p></div>`;
  const hitung = host.querySelector('.bk-hitung b');
  host.querySelectorAll('.sk-pena').forEach(b => b.addEventListener('click', () => {
    aktif = b.dataset.k;
    host.querySelectorAll('.sk-pena').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
    ctx.sfx.tap();
  }));
  const tandai = el => {
    const t = token[+el.dataset.i];
    if (el.classList.contains('ya')) return;
    if (t.kat && (t.kat === aktif || t.kat === '*')) {
      const k = kat.find(x => x.id === t.kat) || kat[0];
      el.classList.add('ya'); el.style.setProperty('--w', WARNA[k.warna] || WARNA.sun);
      letup(el); ctx.sfx.ok?.();
      hitung.textContent = ++benar;
      if (benar === total) { host.querySelectorAll('.sk-kata, .sk-pena').forEach(x => { x.setAttribute('aria-disabled', 'true'); x.tabIndex = -1; }); ctx.selesai(p.selesai || 'Semua sudah ditandai. Hebat! Tekan **Lanjut**.'); }
      else ctx.ucap(p.petunjuk?.[t.kata] || '', 'happy');
    } else {
      goyang(el); ctx.sfx.no();
      const salahWarna = t.kat && t.kat !== aktif;
      ctx.ucap(salahWarna ? `Kata **${esc(t.kata)}** memang perlu ditandai, tetapi dengan stabilo **${esc(kat.find(x => x.id === t.kat)?.nama || '')}**.` : (p.petunjuk?.[aktif] || `**${esc(t.kata)}** bukan yang dicari. Coba kata lain.`), 'think');
    }
  };
  host.querySelectorAll('.sk-kata').forEach(el => {
    el.addEventListener('click', () => tandai(el));
    el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tandai(el); } });
  });
}

/**
 * Coba ganti kata: kata bertanda [..] di kalimat diganti pilihan; kalimat berubah langsung.
 * param: { soal: [{ kalimat: 'Dengan [menerapkan] kebiasaan ...', pilihan: [{ kata, benar, alasan }] }], selesai? }
 */
export function gantiKata(host, p, ctx) {
  let r = 0;
  const tampil = () => {
    const s = p.soal[r];
    const [a, kata, b] = s.kalimat.split(/\[|\]/);
    // "[…]" = isian kosong: tidak ada kata asli yang dicoret.
    const kosong = /^(…|\.\.\.)$/.test(kata.trim());
    host.innerHTML = `<div class="wg wg-baca">
      ${p.soal.length > 1 ? `<p class="bk-hitung">Kalimat ${r + 1} dari ${p.soal.length}</p>` : ''}
      <p class="gk-kalimat">${kaya(a)}<span class="gk-slot${kosong ? ' kosong' : ''}">${kosong ? '' : `<s class="gk-asli">${kaya(kata)}</s>`}<b class="gk-baru" aria-live="polite">${kosong ? '&nbsp;…&nbsp;' : kaya(kata)}</b></span>${kaya(b)}</p>
      <p class="muted gk-ajak">${kosong ? 'Ketuk kata yang paling cocok, lalu baca kalimatnya. Masih masuk akal?' : 'Ketuk kata pengganti, lalu baca kalimatnya. Masih masuk akal?'}</p>
      <div class="gk-opsi">${acak(s.pilihan.map((x, i) => ({ ...x, i }))).map(x => `<button type="button" class="btn gk-b" data-i="${x.i}">${kaya(x.kata)}</button>`).join('')}</div></div>`;
    const slot = host.querySelector('.gk-slot'), baru = host.querySelector('.gk-baru');
    host.querySelectorAll('.gk-b').forEach(btn => btn.addEventListener('click', async () => {
      const x = s.pilihan[+btn.dataset.i];
      slot.classList.add('ganti'); slot.classList.toggle('cocok', !!x.benar); slot.classList.toggle('aneh', !x.benar);
      baru.innerHTML = kaya(x.kata);
      animasi(baru, [{ transform: 'translateY(-12px)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 260 });
      if (!x.benar) { btn.disabled = true; ctx.sfx.no(); ctx.ucap(x.alasan || 'Kalimatnya jadi aneh, ya? Coba kata lain.', 'think'); return; }
      ctx.sfx.ok?.();
      host.querySelectorAll('.gk-b').forEach(y => { y.disabled = true; });
      if (r < p.soal.length - 1) { ctx.ucap(x.alasan || 'Cocok! Kalimatnya tetap masuk akal.', 'cheer'); await jeda(1600); r++; tampil(); }
      else ctx.selesai(x.alasan ? `${x.alasan} Tekan **Lanjut**.` : 'Cocok! Kamu menemukan maknanya. Tekan **Lanjut**.');
    }));
  };
  tampil();
}

/**
 * Pilah kartu ke kelompok: satu kartu tampil, anak mengetuk kelompok yang tepat.
 * param: { kelompok: [{ id, nama, ikon?, warna? }], kartu: [{ teks, ke, alasan? }], acak?: true, selesai? }
 */
export function kelompokkan(host, p, ctx) {
  const antre = p.acak === false ? [...p.kartu] : acak(p.kartu);
  let i = 0;
  host.innerHTML = `<div class="wg wg-baca wg-pilah">
    <div class="pl-antre" aria-live="polite"></div>
    <div class="pl-kelompok" style="--n:${p.kelompok.length}">${p.kelompok.map(k => `<button type="button" class="pl-k" data-k="${esc(k.id)}" style="--w:${WARNA[k.warna] || WARNA.sky}">
      <span class="pl-kepala">${k.ikon ? `<span class="pl-ikon" aria-hidden="true">${esc(k.ikon)}</span>` : ''}<b>${kaya(k.nama)}</b></span><span class="pl-isi"></span></button>`).join('')}</div></div>`;
  const wadah = host.querySelector('.pl-antre');
  const tampil = () => {
    if (i >= antre.length) { wadah.innerHTML = '<b>Semua kartu sudah dipilah!</b>'; return; }
    wadah.innerHTML = `<span class="muted">Kartu ${i + 1} dari ${antre.length}</span><div class="pl-kartu">${kaya(antre[i].teks)}</div>`;
    animasi(wadah.querySelector('.pl-kartu'), [{ transform: 'translateY(-14px) rotate(-3deg)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 300 });
  };
  host.querySelectorAll('.pl-k').forEach(b => b.addEventListener('click', async () => {
    if (i >= antre.length) return;
    const c = antre[i];
    if (b.dataset.k !== c.ke) {
      ctx.sfx.no(); goyang(wadah.querySelector('.pl-kartu'));
      ctx.ucap(c.alasan ? `Belum tepat. ${c.alasan}` : 'Belum tepat. Baca kartunya sekali lagi.', 'think');
      return;
    }
    ctx.sfx.ok?.();
    b.querySelector('.pl-isi').insertAdjacentHTML('beforeend', `<span class="pl-chip">${kaya(c.teks)}</span>`);
    letup(b);
    ctx.ucap(c.alasan || '', 'happy');
    i++;
    if (i >= antre.length) { tampil(); host.querySelectorAll('.pl-k').forEach(x => { x.disabled = true; }); await jeda(300); ctx.selesai(p.selesai || 'Semua kartu sudah di tempat yang tepat! Tekan **Lanjut**.'); }
    else tampil();
  }));
  tampil();
}

// Gunung alur cerita: titik-titik di sepanjang lengkungan, diberi nomor.
function gunungSVG(n, label = []) {
  const W = 520, H = 172, x0 = 30, x1 = W - 30;
  const xs = Array.from({ length: n }, (_, k) => x0 + ((x1 - x0) * k) / Math.max(1, n - 1));
  // Naik sampai puncak (konflik memuncak) di sekitar 65%, lalu turun ke penyelesaian.
  const tinggi = x => { const t = (x - x0) / (x1 - x0), naik = t <= 0.65 ? t / 0.65 : 1 - ((t - 0.65) / 0.35) * 0.65; return 128 - naik * 100; };
  const titik = xs.map(x => [x, tinggi(x)]);
  const d = titik.map(([x, y], k) => `${k ? 'L' : 'M'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  return `<svg class="ur-gunung" viewBox="0 0 ${W} ${H}" aria-hidden="true"><path d="${d}" class="ur-jalur"/>${titik.map(([x, y], k) => `<g class="ur-titik" data-k="${k}"><circle cx="${x}" cy="${y}" r="15"/><text x="${x}" y="${y + 5}" text-anchor="middle">${k + 1}</text>${label[k] ? `<text x="${x}" y="${Math.min(H - 4, y + 32)}" text-anchor="middle" class="ur-label">${esc(label[k])}</text>` : ''}</g>`).join('')}</svg>`;
}

/**
 * Urutkan peristiwa/langkah: ketuk kartu sesuai urutan yang benar.
 * param: { item: [teks...] (urutan benar), gaya?: 'alur', label?: [...], petunjuk?: [teks per posisi], selesai? }
 */
export function urutkan(host, p, ctx) {
  const n = p.item.length, sisa = acak(p.item.map((t, i) => ({ t, i })));
  let pos = 0;
  host.innerHTML = `<div class="wg wg-baca wg-urut">
    ${p.gaya === 'alur' ? gunungSVG(n, p.label) : ''}
    <ol class="ur-slot">${p.item.map((_, k) => `<li data-k="${k}"><span class="ur-no">${k + 1}</span><span class="ur-isi">${p.label?.[k] ? `<i>${esc(p.label[k])}</i>` : '…'}</span></li>`).join('')}</ol>
    <p class="muted">Ketuk kartu yang terjadi lebih dulu:</p>
    <div class="ur-kartu">${sisa.map(x => `<button type="button" class="btn ur-b" data-i="${x.i}">${kaya(x.t)}</button>`).join('')}</div></div>`;
  host.querySelectorAll('.ur-b').forEach(b => b.addEventListener('click', async () => {
    const i = +b.dataset.i;
    if (i !== pos) {
      ctx.sfx.no(); goyang(b);
      ctx.ucap(p.petunjuk?.[pos] ? `Belum. Petunjuk: ${kaya(p.petunjuk[pos])}` : 'Belum. Peristiwa itu terjadi nanti. Cari yang lebih dulu.', 'think');
      return;
    }
    ctx.sfx.ok?.();
    const li = host.querySelector(`.ur-slot li[data-k="${pos}"]`);
    li.querySelector('.ur-isi').innerHTML = kaya(p.item[i]);
    li.classList.add('isi'); letup(li);
    host.querySelector(`.ur-titik[data-k="${pos}"]`)?.classList.add('isi');
    b.remove();
    pos++;
    ctx.ucap('', 'happy');
    if (pos === n) { await jeda(250); ctx.selesai(p.selesai || 'Urutannya tepat! Tekan **Lanjut**.'); }
  }));
}

// ---------- visual statis untuk langkah materi ----------
/** Diagram payung: kalimat utama memayungi kalimat-kalimat penjelas. */
export function diagramPayung(utama, penjelas) {
  return `<div class="vb-payung"><svg class="vb-atap" viewBox="0 0 200 56" aria-hidden="true"><path d="M6 54 Q100 -26 194 54 Q172 42 150 54 Q125 42 100 54 Q75 42 50 54 Q28 42 6 54Z" class="vb-kain"/></svg>
    <div class="vb-utama"><small>Kalimat utama</small>${kaya(utama)}</div>
    <div class="vb-bawah">${penjelas.map(t => `<span><small>Kalimat penjelas</small>${kaya(t)}</span>`).join('')}</div></div>`;
}
/** Rantai sebab → akibat. */
export function rantai(langkah) {
  return `<div class="vb-rantai">${langkah.map((t, i) => `${i ? '<span class="vb-panah" aria-hidden="true">→</span>' : ''}<span class="vb-mata">${kaya(t)}</span>`).join('')}</div>`;
}
/** Gunung alur bergambar dengan keterangan di setiap titik. */
export const gunungAlur = label => `<div class="wg-urut">${gunungSVG(label.length, label)}</div>`;

export const WIDGET_BAHASA = { pilihKalimat, sorotKata, gantiKata, kelompokkan, urutkan };
